import * as Yup from 'yup';

export const informationValidation = Yup.object().shape({
  otp: Yup.string().required('Vui lòng nhập mã xác thực'),
});
